import {BasketIconName} from './iconNames';

export const basketIconAssets = {
  [BasketIconName.Empty]: require('./assets/ic-empty-basket.svg'),
  [BasketIconName.Sale]: require('./assets/sale.svg'),
};
